/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function LanguageProficiency() {
    const tableName = 'Language';
    const spouseLanguageProficiency = 'SpouseLanguage';
    const [dataList, setData] = useState<any>();
    const [spouseLangProf, setSpouseLangProf] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        setSpouseLangProf(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
        api.tableInput.fetchCandidateInput(
            setSpouseLangProf,
            spouseLanguageProficiency,
            candidate_id
        );
    }, [candidate_id]);

    return (
        <>
            <div>
                <S.Title>Applicant</S.Title>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.BoxPart1>
                            <h4>Language</h4>

                            <S.Value> {data?.language}</S.Value>
                            <S.BoxPart2>
                                <h4>Test Type</h4>
                                <h4>Level</h4>
                                <S.Value>{data?.test_type}</S.Value>

                                <S.Value>
                                    {data
                                        ? data.level === '5'
                                            ? 'Native speaker'
                                            : data.level
                                        : ''}
                                </S.Value>
                                {data && data.level !== '5' && (
                                    <>
                                        <h4>Speaking</h4>
                                        <h4>Listening</h4>
                                        <S.Value>{data?.speaking}</S.Value>
                                        <S.Value>{data?.listening}</S.Value>
                                        <h4>Reading</h4>
                                        <h4> Writing </h4>
                                        <S.Value>{data?.reading}</S.Value>
                                        <S.Value>{data?.writing}</S.Value>
                                    </>
                                )}
                            </S.BoxPart2>
                        </S.BoxPart1>
                    </span>
                ))}
            </div>
            <div>
                <S.Title>Spouse</S.Title>
                {spouseLangProf?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.BoxPart1>
                            <h4>Language</h4>
                            <S.Value> {data?.language}</S.Value>
                            <S.BoxPart2>
                                <h4>Test Type</h4>
                                <h4>Level</h4>
                                <S.Value>{data?.test_type}</S.Value>

                                <S.Value>{data?.level}</S.Value>
                                <h4>Speaking</h4>
                                <h4>Listening</h4>
                                <S.Value>{data?.speaking}</S.Value>
                                <S.Value>{data?.listening}</S.Value>
                                <h4>Reading</h4>
                                <h4> Writing </h4>
                                <S.Value>{data?.reading}</S.Value>
                                <S.Value>{data?.writing}</S.Value>
                            </S.BoxPart2>
                        </S.BoxPart1>
                    </span>
                ))}
            </div>
        </>
    );
}
